import createModule from "../createModule"
import { getErrorMessage, getProvider } from "./selectors/index"
import view from "./view"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    error: getErrorMessage(state, props),
    provider: getProvider(state, props),
  }),
})
